// components\MQTTService.tsx
import mqtt from 'mqtt';
import { compressMessage } from './utils//MQTTMessageMapper'; // ✅ 경로와 파일명 반드시 확인

class MQTTService {
  private static instance: MQTTService;
  private client: mqtt.MqttClient;
  private brokerUrl = process.env.REACT_APP_MQTT_BROKER_URL || 'wss://broker.i2r.link:8084/mqtt';


  private constructor() {
    this.client = mqtt.connect(this.brokerUrl, {
      username: process.env.REACT_APP_MQTT_USER,
      password: process.env.REACT_APP_MQTT_PASS,
      reconnectPeriod: 5000,
      rejectUnauthorized: false
    });

    this.client.on('connect', () => {
      console.log('✅ MQTT Service Connected to Broker');
    });

    this.client.on('error', (error) => {
      if (error && error.message && error.message.includes('$SYS')) {
        console.warn('⚠️ Ignored MQTT System Topic Error (likely external/extension):', error.message);
        return;
      }
      console.error('❌ MQTT Connection Error:', error);
    });
  }

  public static getInstance(): MQTTService {
    if (!MQTTService.instance) {
      MQTTService.instance = new MQTTService();
    }
    return MQTTService.instance;
  }


  public getClient(): mqtt.MqttClient {
    return this.client;
  }


  public publish(topic: string, fullMessage: string): void {
    try {
      const original = JSON.parse(fullMessage);
      const compressed = compressMessage(original); // ✅ 축약 변환
      //const message = JSON.stringify(compressed);

      // ✅ 다시 문자열로 변환 (publish용)
      const payload = JSON.stringify(compressed);
      // API 키가 들어 있는 메시지는 콘솔에 남기지 않는다.
      if (original.command === 'apiKey') {
        console.log(`📤 MQTT Publish to ${topic} (API 키 메시지, 내용은 기록하지 않음)`);
      } else {
        console.groupCollapsed(`📤 MQTT Publish to ${topic}`);
        console.log('Full message:', fullMessage);
        console.log('Original Full message:', original);
        console.log('Compressed message:', compressed);
        console.log('Payload string:', payload);
        console.groupEnd();
      }

      this.client.publish(topic, payload, (err) => {
        if (err) {
          console.error('Publish Error:', err);
        } else {
          //console.log(`✅ ==== MQTT publish to ${topic}:`, message);
        }
      });
    } catch (error) {
      console.error('Error parsing or publishing MQTT message:', error);
    }
  }

}

export default MQTTService;
